import { ethers } from "ethers"
import {
  INFURA_ID,
  NETWORKS,
  CURRENT_ENV,
  WALLET_PROVIDER,
} from "constants/config"

const getWalletProviders = () => {
  /// 📡 What chain are your contracts deployed to?
  let targetNetwork = NETWORKS.localhost
  if (CURRENT_ENV === "production") {
    targetNetwork = NETWORKS.mainnet
  } else if (CURRENT_ENV === "staging") {
    targetNetwork = NETWORKS.goerli
  } else {
    targetNetwork = NETWORKS.localhost
  } // <------- select your target frontend network (localhost, rinkeby, xdai, mainnet)

  // 🏠 Your local provider is usually pointed at your local blockchain
  const localProviderUrl = targetNetwork.rpcUrl
  // as you deploy to other networks you can set REACT_APP_PROVIDER=https://dai.poa.network in packages/react-app/.env
  const localProviderUrlFromEnv = WALLET_PROVIDER
    ? WALLET_PROVIDER
    : localProviderUrl

  const localProvider = new ethers.providers.StaticJsonRpcProvider(
    localProviderUrlFromEnv
  )

  const scaffoldEthProvider = navigator.onLine
    ? new ethers.providers.StaticJsonRpcProvider(
        "https://rpc.scaffoldeth.io:48544"
      )
    : null
  const poktMainnetProvider = navigator.onLine
    ? new ethers.providers.StaticJsonRpcProvider(
        "https://eth-mainnet.gateway.pokt.network/v1/lb/611156b4a585a20035148406"
      )
    : null
  const mainnetInfura = navigator.onLine
    ? new ethers.providers.StaticJsonRpcProvider(
        "https://mainnet.infura.io/v3/" + INFURA_ID
      )
    : null

  const mainnetProvider =
    poktMainnetProvider && poktMainnetProvider._isProvider
      ? poktMainnetProvider
      : scaffoldEthProvider && scaffoldEthProvider._network
      ? scaffoldEthProvider
      : mainnetInfura

  return { localProvider, mainnetProvider }
}

export { getWalletProviders }
